import { createSlice } from '@reduxjs/toolkit'

// function removeElement(array, element) {
//     return array.filter(item => item !== element);
// }

const transformacijaDataSlice = createSlice({
    name: 'transformacijaData',
    initialState: { 
                    tezina: "", 
                    visina: "", 
                    pol: "", 
                    primcilj: "", 
                    specilj: [], 
                    godine: "", 
                    datumRodjenja: "",
                    dijagnoza: "", 
                    ucestBr: "", 
                    navikeUish: "", 
                    namirnice: [],
                    namirniceDa: [],
                    voljeneNamirnice: "", 
                    neVoljeneNamirnice: "",
                    PokreniTransformaciju: "",
                    ukupnaKalVred: "",
                    tabTrigger: false ,
                    tdee: "",
                    bmi: "",
                    selectedIshranaNaziv: "",
                    kuk: "",
                    struk: "",
                    vrat: "",
                    krv: "",
                    motiv: "",
                    nivoAkt: "",
                    vrstaFiz: [],
                    alerg: "",
                    pus: "",
                    alk: "",
                    bmrValue: "",
                    imunitet: "",
                    iskSaDijetama: "",
                    intolerancija: ""
                },
    reducers: {
        setTransformacijaData: (state, action) => {
            return { ...state, ...action.payload };
        },
        setTabTrigger: (state, action) => {
            state.tabTrigger = action.payload;  //Postavlja vrednost u nasem slucaju na true u aplikaciji
        },
        resetTabTrigger: (state) => {
            state.tabTrigger = false; // Reset to default
        }
        // resetTransformacijaData: (state) => {
        //     return initialState; // Resetting to initial state
        // },
    }
})

export const { setTransformacijaData,setTabTrigger,resetTabTrigger  } = transformacijaDataSlice.actions

export default transformacijaDataSlice.reducer

export const selectTabTrigger = (state) => state.transformacijaData.tabTrigger;

// export const datum = (state) => state.obracuniKeyData.datum

// export const selectPositionsIds = (state) => state.obracuniKeyData.positions.ids

// addPosition: (state, action) => {
//     const { organizacijaId,organizacijaName ,fixUgovoren,kafa,zaRacDnev,netopalataIzUgovora,pozicija,tipUgovora,sektor } = action.payload
//     // const { organizacijaId,organizacijaName,fixUgovoren,selectedOptionKafa, selectedOptionDnevnica, netoPlataUgovor ,pozcicijaName, tipUgovoraName,sektorName } = action.payload
//     state.positions.ids.push(organizacijaId)
//     state.positions.entities[organizacijaId] = { _id: organizacijaId,name: organizacijaName, fixUgovoren: fixUgovoren, kafa,zaRacDnev,netopalataIzUgovora,pozicija,tipUgovora,sektor }
//     //state.positions.entities.push({ _id: organizacijaId,name: organizacijaName, fixUgovoren: fixUgovoren,selectedOptionKafa: selectedOptionKafa, selectedOptionDnevnica: selectedOptionDnevnica, netoPlataUgovor: netoPlataUgovor ,pozcicijaName: pozcicijaName, tipUgovoraName: tipUgovoraName,sektorName: sektorName })
// },
// //BRISE SVE REDOVE SA AKO IM JE ISTA ORGANIZACIJA ZATO STO IM JE ISTI ID!
// //AKO ZELIS DA PROMENIS OND AGA MORAS VEZATI OVDE SA NEKIM NOVIM ID SAMO U MEMORIJI
// removePosition: (state, action) => {
//     const { pozicijaId } = action.payload
//     //Ids
//     state.positions.ids = removeElement(state.positions.ids, pozicijaId);

//     //Entities
//     if (state.positions.entities.hasOwnProperty(pozicijaId)) {
//         delete state.positions.entities[pozicijaId];
//     } else {
//         console.log(`Key ${pozicijaId} ne postoji u objektu.`);
//     }
    
// },
// resetPositions: (state, action) => {
//     state.positions = { ids: [], entities: {} } 
// },